/* eslint-disable */
import { errorMsg } from '../constants/messages';

const acceptableImageFormat = ['image/png', 'image/jpg', 'image/jpeg'];

const serviceCardsFormData = [
  {
    title: 'Service Card Details',
    name: 'heading',
    label: 'Service Category',
    fieldType: {
      name: 'select',
      options: [],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service Category',
      allowAddRecordClick: true,
      enableFilter: true,
      filterOptions: [],
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'serviceName',
    label: 'Package Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Package Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'packageName',
    label: 'Description',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Description', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'image',
    label: 'Service Image',
    fieldType: {
      name: 'documitraFile',
      accept: acceptableImageFormat,
      maxCount: '1',
      allowImageCropping: true,
    },
    placeholder: 'Click here to select',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service Image',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'image',
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'cardLink',
    label: 'Package Link (URL)',
    fieldType: {
      name: 'text',
    },
    placeholder: 'e.g., /package/oci-services/new-oci',
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Package Link', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'isActive',
    label: 'Is Active',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Is Active',
      enableSort: false,
      columnType: 'active',
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'tag',
    label: 'Tag',
    fieldType: {
      name: 'text',
    },
    placeholder: 'e.g., Popular, New, Featured, etc.',
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Tag',
      enableSort: false,
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: true,
  },
];

export { serviceCardsFormData };
